/**
 * @flow
 * @relayHash ed8d15576b2002920155ed87801faceb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GLAccountType = "ASSET" | "COGS" | "EQUITY" | "EXPENSE" | "LIABILITY" | "REVENUE";
export type AccountMappingsQueryVariables = {||};
export type AccountMappingsQueryResponse = {|
  +glAccountMappings: $ReadOnlyArray<{|
    +id: string,
    +mappingKey: string,
    +account: {|
      +id: string,
      +accountNumber: string,
      +name: string,
    |},
  |}>,
  +glAccounts: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +accountNumber: string,
        +name: string,
        +accountType: GLAccountType,
      |}
    |}>
  |},
|};
export type AccountMappingsQuery = {|
  variables: AccountMappingsQueryVariables,
  response: AccountMappingsQueryResponse,
|};
*/


/*
query AccountMappingsQuery {
  glAccountMappings {
    id
    mappingKey
    account {
      id
      accountNumber
      name
    }
  }
  glAccounts(first: 200, isActive: true, sortBy: {field: ACCOUNT_NUMBER, direction: ASC}) {
    edges {
      node {
        id
        accountNumber
        name
        accountType
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "accountNumber",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "glAccountMappings",
    "storageKey": null,
    "args": null,
    "concreteType": "GLAccountMapping",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "mappingKey",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "account",
        "storageKey": null,
        "args": null,
        "concreteType": "GLAccount",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "glAccounts",
    "storageKey": "glAccounts(first:200,isActive:true,sortBy:{\"direction\":\"ASC\",\"field\":\"ACCOUNT_NUMBER\"})",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      },
      {
        "kind": "Literal",
        "name": "isActive",
        "value": true
      },
      {
        "kind": "Literal",
        "name": "sortBy",
        "value": {
          "direction": "ASC",
          "field": "ACCOUNT_NUMBER"
        }
      }
    ],
    "concreteType": "GLAccountConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "GLAccountEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "GLAccount",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AccountMappingsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AccountMappingsQuery",
    "argumentDefinitions": [],
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "AccountMappingsQuery",
    "id": null,
    "text": "query AccountMappingsQuery {\n  glAccountMappings {\n    id\n    mappingKey\n    account {\n      id\n      accountNumber\n      name\n    }\n  }\n  glAccounts(first: 200, isActive: true, sortBy: {field: ACCOUNT_NUMBER, direction: ASC}) {\n    edges {\n      node {\n        id\n        accountNumber\n        name\n        accountType\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f9a76eda75f0df3d7dfe585984e1469b';
module.exports = node;
